module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_six-5e55c05f3a4111144bc3b98b67bd1937.png";